__turbopack_context__.v({
  "container": "InstagramFeed-module__eXC0QW__container",
  "playButton": "InstagramFeed-module__eXC0QW__playButton",
  "postGrid": "InstagramFeed-module__eXC0QW__postGrid",
  "postImage": "InstagramFeed-module__eXC0QW__postImage",
  "postLink": "InstagramFeed-module__eXC0QW__postLink",
});
